/**
 * Clase que representa un archivo adjunto con detalles adicionales.
 * @class AttachedFile
 */
export class AttachedFile {
  uuid?: string;
  fileId?: string;
  file?: File;
  name: string;
  title: string;
  description: string;
  mimeType?: string;
  size?: number;
  lastModDate?: number | string | Date;
  versionType?: string;
  versionLabel?: string;

  /**
  * Constructor que acepta el nombre del archivo y opcionalmente el identificador único y el archivo adjunto.
  * @param {string} name - Nombre del archivo.
  * @param {string | undefined} fileId - Identificador único del archivo (opcional).
  * @param {File | undefined} file - Archivo adjunto (opcional).
  */
  constructor(name: string, fileId?: string, file?: File) {
    this.name = name;
    this.fileId = fileId;
    this.file = file;
  }
}